import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useQuickFiltersContext } from 'modules/expenses/components/expenses/PageContents/QuickFiltersContext'
import { MyGroupedExpensesDataTable } from 'modules/expenses/components/my_groups/expenses/Datatable'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { Group } from 'modules/expenses/hooks/useGroup'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'
import expensesCategoriesContractsTaxonomies from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

export interface ListProps {
  group: Group
  back: { href: string }
}

const ExpensesList = ({ group, back }: React.PropsWithChildren<ListProps>) => {
  const [availableCategories, setAvailableCategories] = React.useState<string[] | undefined>(
    undefined
  )
  const [currentPeriodOpen, setCurrentPeriodOpen] = React.useState<boolean>(false)
  const { filters } = useQuickFiltersContext()
  const { company } = useCurrentSession()

  const { data } = useMyExpenses()

  const {
    categories,
    subcategories,
    currencies,
    canSeeTransactions,
    hasExpensesReportOnBehalfFeature,
    canUsePerDiems,
    loading,
  } = useExpensesListPage({ companyId: company.id, skipProjectsQuery: true })

  const { loading: loadingPayroll } = useAsyncData(
    () =>
      Promise.all([
        expensesCategoriesContractsTaxonomies.existingTaxonomies().then((categories) => {
          setAvailableCategories(categories)
        }),
        policyPeriods.isCurrentOpen().then(({ open_to_supplements }) => {
          setCurrentPeriodOpen(open_to_supplements)
        }),
      ]),
    []
  )

  if (loading || loadingPayroll) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return (
    <MyGroupedExpensesDataTable
      key={JSON.stringify(filters)} //re-mount the datatable if expensable search params change
      group={group}
      subcategories={subcategories}
      currencies={currencies}
      currentPayrollPeriodOpen={currentPeriodOpen}
      availablePayrollCategories={availableCategories || []}
      categories={categories}
      back={back}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      canSeeTransactions={canSeeTransactions}
      canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
      canCreateExpenses={data.expenses._policies.expenseCreateExpenses.can}
      canUsePerDiems={canUsePerDiems}
    />
  )
}

export default observer(ExpensesList)
